export default __webpack_public_path__ + "82bc5bb.png";